module.exports = __webpack_public_path__ + "static/media/retirement-spot-clear.3632dd8e.svg";